$("[cart-quantity-item]").on("card:quantity:update", (el) => {
  let currentEl = el.currentTarget;
  let quantity = parseInt(currentEl.value);
  let id = parseInt(currentEl.dataset.productId);
  swCartUpdate(id, quantity).then((cartData) => {
    if (cartData) {
      $("[cart-drawer-heading-count]").html( cartData.item_count );
      let prdct_price = parseInt(currentEl.dataset.price) * quantity;
      $(currentEl)
        .parents(".product_quantity_box")
        .find(".price")
        .html(Shopify.formatMoney(prdct_price));
      $("[sw-total-wraper]")
        .find(".total_price")
        .html(Shopify.formatMoney(cartData.total_price));
        $("[cart-drawer-heading]").html("Your Cart(" + cartData.item_count + " items)");
        
    } else {
      location.reload();
    }
  });
});

$('#search-in-template').on('input', function() {
  if ($(this).val().trim() !== '') {
    $('#SearchSuggestion').addClass('hidden');
  } else {
    $('#SearchSuggestion').removeClass('hidden');
  }
});